document.addEventListener('DOMContentLoaded', function () {
  var block = document.querySelector('.cro-block');
  if (!block) return;

  /* ---- Tabs ---- */
  var tabHeaders = block.querySelectorAll('.cro-tab-header');
  var tabPanels = block.querySelectorAll('.cro-tab-panel');
  tabHeaders.forEach(function (header) {
    header.addEventListener('click', function () {
      var target = header.getAttribute('data-cro-tab');
      tabHeaders.forEach(function (h) { h.classList.remove('is-active'); });
      tabPanels.forEach(function (p) { p.classList.remove('is-active'); });
      header.classList.add('is-active');
      var panel = block.querySelector('[data-cro-panel="' + target + '"]');
      if (panel) panel.classList.add('is-active');
    });
  });

  /* ---- Quantity stepper ---- */
  var qtyInput = block.querySelector('[data-cro-qty-input]');
  var qtyMinus = block.querySelector('[data-cro-qty-minus]');
  var qtyPlus = block.querySelector('[data-cro-qty-plus]');

  function syncQtyToShopify(value) {
    var formQty = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
    if (formQty) formQty.value = value;
  }

  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', function () {
      var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      qtyInput.value = val;
      syncQtyToShopify(val);
    });
  }
  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', function () {
      var val = (parseInt(qtyInput.value, 10) || 1) + 1;
      qtyInput.value = val;
      syncQtyToShopify(val);
    });
  }
  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      var val = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      qtyInput.value = val;
      syncQtyToShopify(val);
    });
  }

  /* ---- Size pills: mirror clicks onto the theme's real variant selector ---- */
  var sizePills = block.querySelectorAll('[data-cro-size]');
  var currentSizeLabel = block.querySelector('[data-cro-size-current]');

  sizePills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      if (pill.getAttribute('aria-disabled') === 'true') return;
      var size = pill.getAttribute('data-cro-size');

      sizePills.forEach(function (p) { p.classList.remove('is-selected'); });
      pill.classList.add('is-selected');
      if (currentSizeLabel) currentSizeLabel.textContent = size;

      var nativeRadio = document.querySelector(
        'input[type="radio"][value="' + size + '"], input[type="radio"][data-value="' + size + '"]'
      );
      if (nativeRadio) {
        nativeRadio.checked = true;
        nativeRadio.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      var nativeSelect = document.querySelector('select[name="Size"], select[data-option-name="Size"]');
      if (nativeSelect) {
        Array.prototype.forEach.call(nativeSelect.options, function (opt) {
          if (opt.value === size || opt.textContent.trim() === size) {
            nativeSelect.value = opt.value;
            nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        return;
      }

      var nativeButtons = document.querySelectorAll('[data-option-value], .variant-input, .swatch-input__input');
      nativeButtons.forEach(function (btn) {
        var val = btn.getAttribute('data-option-value') || btn.value || btn.textContent.trim();
        if (val === size) {
          if (btn.tagName === 'INPUT') {
            btn.checked = true;
            btn.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            btn.click();
          }
        }
      });
    });
  });
});
